import React from 'react';
import { DEFAULT_ICON_SIZE } from '../../constants';
import type { GoIconProps } from '../../types';

const GoTimesIcon = ({ size = DEFAULT_ICON_SIZE, color = 'currentColor' }: GoIconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill={color} viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M13.066 4.182a.8.8 0 0 0-1.131-1.132L8 6.985 4.066 3.05a.8.8 0 0 0-1.131 1.132l3.934 3.934-3.702 3.702a.8.8 0 1 0 1.13 1.132L8 9.247l3.703 3.703a.8.8 0 0 0 1.131-1.132L9.132 8.116z"
            clipRule="evenodd"
        />
    </svg>
);
GoTimesIcon.id = 'GoTimesIcon';
GoTimesIcon.displayName = 'GoTimesIcon';
export default GoTimesIcon;
